(function() {
  window.onload = () => {
    let html = document.getElementsByTagName("html")[0];
    var oldWidth = html.clientWidth || document.documentElement.clientWidth;
    if (oldWidth >= 800) {
      getRem(1920, 100);
    } else {
      getRem(720, 100);
    }
  };

  window.onresize = () => {
    let html = document.getElementsByTagName("html")[0];
    var oldWidth = html.clientWidth || document.documentElement.clientWidth;
    if (oldWidth >= 800) {
      getRem(1920, 100);
    } else {
      getRem(720, 100);
    }
  };
  function getRem(pwidth, prem) {
    let html = document.getElementsByTagName("html")[0];
    var oldWidth = html.clientWidth || document.documentElement.clientWidth;
    html.style.fontSize = (oldWidth / pwidth) * prem + "px";
  }
})();
